import { GridLinkOperator } from '../../../models/gridFilterItem';
export const getDefaultGridFilterModel = () => ({
  items: [],
  linkOperator: GridLinkOperator.And,
  quickFilterValues: [],
  quickFilterLogicOperator: GridLinkOperator.And
});